import React, { useState } from "react";
import Swipeable from "../../../../Fronts/Main/Swipeable";
import Grid from "@material-ui/core/Grid";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Divider from "@material-ui/core/Divider";
import { colors, Hidden, Paper } from "@material-ui/core";
import { SharedGroupIdProvider } from "../../../Invs/BackEnd/InvoiceRest/RestProductsG";
import GroupLists from "../../../Invs/BackEnd/InvoiceRest/GroupLists";
import { GroupSelectRest } from "../../../Invs/BackEnd/POS/GroupSelectRest";
import { permOtherAccount, permOtherSafes } from "../checksPermmision";
import CheckboxItems, { useStylesAccs } from "../CheckBoxComponents";

export default function AccountsPermission(props) {
    const { onChange, object, viewHandle, formsData, setFormsData } = props;
    const typeSetting = [
        { id: 0, name: "القيود اليومية", Form_id: 60002, color: -1 },
        { id: 1, name: "سندات قبض خارجي", Form_id: 50001, color: -1 },
        { id: 2, name: "سندات صرف خارجي", Form_id: 50002, color: -1 },
        { id: 3, name: "سندات قبض داخلي", Form_id: 50003, color: -1 },
        { id: 4, name: "سندات قبض داخلي", Form_id: 50003, color: -1 },
        { id: 5, name: "سندات صرف داخلي", Form_id: 50004, color: -1 },
        { id: 6, name: "سند صرف  متعدد", Form_id: 50007, color: -1 },
        { id: 7, name: "سند قبض  متعدد", Form_id: 50008, color: -1 },
    ];

    const classes = useStylesAccs();
    const [saleSetting, setSaleSetting] = useState(typeSetting[0]);
    const [selectColor, setSelectColor] = useState({ id: 0, color: colors.blue[300] });

    const onRowClick = (row) => {
        setSaleSetting(row);
        setSelectColor({ ...row, color: colors.blue[300] });
        setFormsData({ ...formsData, Form_id: row.Form_id });
        if (row.Form_id !== 1000) {
            viewHandle(formsData.user.id, row.Form_id);
        }
    };
    return (
        <div className={classes.root}>
            <Accordion expanded={true}>
                <Grid item xs={12} container spacing={0} >

                    <Grid item lg={2} md={2} sm={12} xs={12}>
                        <Hidden smDown>
                            <Paper
                                style={{ minHeight: "100%", maxHeight: "100%", overflow: "auto", }}
                            >
                                <SharedGroupIdProvider>
                                    <GroupLists
                                        groups={[...typeSetting]}
                                        onRowClick={onRowClick}
                                        isMain={true}
                                        GroupColor={selectColor}
                                    />
                                    <Divider />
                                </SharedGroupIdProvider>
                            </Paper>
                        </Hidden>
                        <Hidden mdUp>
                            <GroupSelectRest
                                groups={[...typeSetting]}
                                onRowClick={onRowClick}
                                isMain={true}
                                GroupColor={selectColor}
                            />
                        </Hidden>
                    </Grid>

                    <Grid item lg={10} md={10} sm={12} xs={12}>
                        <div
                            style={{ minHeight: "100%", maxHeight: "100%", overflow: "auto", }}
                        >
                            <SharedGroupIdProvider>
                                <AccordionDetails >
                                    <Grid item container spacing={1}>
                                        {permOtherAccount
                                            ?.filter((d) => d.visible)
                                            ?.map((item) => {
                                                return (
                                                    <Grid xs={6}>
                                                        <CheckboxItems
                                                            value={object[item.name] ?? null}
                                                            name={item.name}
                                                            label={item.label}
                                                            onChange={onChange}
                                                        />
                                                    </Grid>
                                                );
                                            })}
                                    </Grid>
                                </AccordionDetails>

                            </SharedGroupIdProvider>
                        </div>
                    </Grid>
                </Grid>
            </Accordion>
            <Swipeable />
        </div>
    );
}
